<template>
  <SecondaryVaccinationPage
    title="Adolescents"
    :vaccines="vaccinesList"
    prevRoute="/pregHome"
    nextRoute="/secondPregHome"
    :secondaryImage="require('@/assets/page7/Asset 27.png')"
    :footerBanner1="require('@/assets/page7/Asset 29.png')"
    :footerBanner2="require('@/assets/page4/lowererPanner.png')"
  />
</template>

<script setup>
import SecondaryVaccinationPage from "@/components/SecondaryVaccinationPage.vue";

const vaccinesList = [
  {
    imgPath: require("@/assets/page6/Asset 2.png"),
    name: "Influenza",
    ModalData: {
      Indications: {
        text: "All persons ≥6 months",
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: "One dose every year, preferred before the winter season",
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction,
        Precautions
                Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 5.png"),
    name: "Tetanus",
    ModalData: {
      Indications: {
        text: `Tdap vaccination for adolescents is recommended at age 11–12 years.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `A single intramuscular booster dose of Tdap is recommended for adolescents aged 11–12 years.`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction 	
For Tdap only, history of encephalopathy not attributable to an identifiable cause, within 7d following DTP/DTaP, or Tdap`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 4.png"),
    name: "Humanpapilloma",
    ModalData: {
      Indications: {
        text: `For unvaccinated females, 11 through age 26yrs: Complete a 3-dose series of HPV4/9.
Shared clinical decision-making regarding HPV vaccination is recommended for some adults aged 27 through 45 years who are not adequately vaccinated and want to be protected from ongoing risk of acquiring new HPV infection.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `2-dose series for adolescents who start the vaccination before the 15th birthday (6-12 months apart). 
For individuals 15 years and older, a 3-dose series is recommended on 0, 1-2, 6 months schedule. At least 4wks between 1st and 2nd dose, and at least 12wks between 2nd and 3rd dose.
`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction,
        Precautions
Moderate or severe acute illness
Pregnancy (Not recommended).`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 8.png"),
    name: "COVID-19",
    ModalData: {
      /* eslint-disable */
      Indications: {
        text: `Individuals 12 years and above regardless of previous vaccination. A priority to people with any of the following conditions: 
 Age over 50 years .
Pregnant women .
Chronic heart, lung, kidney, neurological diseases .
Hereditary blood disorders (sickle cell anemia, thalassemia) .
Immunocompromised conditions.
Travelers for Umrah and Hajj.
Healthcare workers with direct patient contact.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: "1 dose intramuscular, 3 months after the most recent dose.",
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `History of a severe allergic reaction after a previous dose or to a component of the COVID-19 vaccine.
Precautions 
Moderate or severe acute illness, with or without fever.
History of a non-severe, immediate (onset less than 4 hours) allergic reaction after administration of a previous dose of one COVID-19 vaccine type.
History of myocarditis or pericarditis within 3 weeks after a dose of any COVID-19 vaccine. 
`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 6.png"),
    name: "Adolescents",
    ModalData: {
      Indications: {
        text: "no data",
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: "no data",
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: "no data",
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 7.png"),
    name: "MeningococcalMenB",
    ModalData: {
      Indications: {
        text: `A single booster dose of MenACWY is recommended at 18 years of age.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `A single intramuscular booster dose of MenACWY is recommended at 18 years of age.`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Severe allergic reaction to a vaccine component or to a prior dose. 
A moderate or severe acute illness is a precaution.`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 11.png"),
    name: "HepatitisA",
    ModalData: {
      Indications: {
        text: `All adults seeking protection from (HAV) infection and persons with other risk factors.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: "2 doses schedule with a minimum of 6 months interval",
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction
        </br>
        Precautions
Moderate or severe acute illness.`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 16.png"),
    name: "HepatitisB",
    ModalData: {
      Indications: {
        text: "Recommended if some other risk factor is present (e.g., occupational, lifestyle, or other indications)",
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `3-doses series at 0, 1 and 6 month intervals.`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction
        </br>
        Precautions
                          Moderate or severe acute illness with or without fever.`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 9.png"),
    name: "MMR",
    ModalData: {
      Indications: {
        text: `Individuals at higher risk of either exposure or morbidity e.g., Healthcare personnel, college students, Military personnel, international travelers, etc.`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `Individuals at high risk should have two doses separated by at least one month or serologic evidence of immunity.All live injected vaccines (MMR, varicella, and yellow fever) are recommended to be given subcutaneously (Subcut).`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Immunocompromising conditions`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page6/Asset 10.png"),
    name: "Varicella",
    ModalData: {
      Indications: {
        text: `All adults without evidence of immunity to varicella`,
        img: require("@/assets/page7/Asset 32.png"),
      },
      Administration: {
        text: `2 doses, 2nd dose is given 4—8wks after 1st dose. If 2nd dose is delayed, do not repeat 1st dose, just give 2nd dose. All live injected vaccines (MMR, varicella, and yellow fever) are recommended to be given subcutaneously (Subcut).`,
        img: require("@/assets/page7/Asset 33.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Long-term immunosuppressive therapy,</br>
        Precautions Moderate or severe acute illness.`,
        img: require("@/assets/page7/Asset 34.png"),
      },
    },
  },
];
</script>
